import { Button } from "@jugl-web/ui-kit";
import { Lottie } from "@jugl-web/utils";
import { FC } from "react";
import errorAnimation from "./assets/error-animation.json";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

interface TicketsLoadingErrorStateProps {
  onRetry: () => void;
}

export const TicketsLoadingErrorState: FC<TicketsLoadingErrorStateProps> = ({
  onRetry,
}) => (
  <div className="flex flex-col items-center justify-center gap-8 p-6 text-center">
    <Lottie
      options={{ animationData: errorAnimation }}
      width={150}
      height={150}
      className="-mb-6"
    />
    <div className="flex flex-col gap-2.5">
      <h2 className="m-0 font-secondary text-2xl leading-[140%] font-medium text-black">
        Oops, something went wrong
      </h2>
      <p className="m-0 font-secondary text-base leading-[150%] font-normal text-[#828282]">
        An issue occurred while loading the page. Please try again.
      </p>
    </div>
    <div className="flex items-center gap-2">
      <Button
        onClick={onRetry}
        iconEnd={<ArrowRightIcon />}
        className="w-[200px]"
      >
        Retry
      </Button>
    </div>
  </div>
);
